import settingsBase from "../helpers/configuration/loadSettings";

// Stesso comportamento tipizzato del precedente require(JSON): oggetto configurazione esteso
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const settings: any = {
	...settingsBase,
	dropdownLanguages: [
		{ code: 'it', label: 'Italiano' },
		{ code: 'en', label: 'English' },
		{ code: 'de', label: 'Deutsch' },
		{ code: 'sl', label: 'Slovenščina' }
	]
};

export default settings;
